import React, {useState, useEffect, useContext} from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ModalPop from 'components/sales/modal/modal';
import {Button} from 'react-bootstrap';
import {BaseUrl} from 'contexts/baseUrl/baseUrl';

const PmSiteApprovals = ({
                             getPmSiteState,
                             sitePmStateList = {},
                             updatePmSiteState
                         }) => {
    const {baseUrl} = useContext(BaseUrl);
    const [listData, setListData] = useState();
    const [isModal, setIsModal] = useState(false);
    const [actionData, setActionData] = useState();
    const [isSuccessModel, setIsSuccessModel] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);


    useEffect(() => {
        if (getPmSiteState !== null) {
            (async () => {
                setIsLoading(true);
                await getPmSiteState();
                setIsLoading(false);
            })();
        }
    }, [getPmSiteState]);

    const Headers = [
        'Site No',
        'Site Name',
        // 'Requested By',
        'state',
        'Status',
        'Remark',
        'Requested On',
        'Approve',
    ];


    useEffect(() => {
        const tableData = [
            'id',
            'site_no',
            'site_name',
            'state',
            // 'name',
            'status',
            'remark',
            'created_at',
        ];

        if (Object.keys(sitePmStateList).length > 0) {
            const data = sitePmStateList.data.map((element) =>
                Object.assign(
                    {},
                    ...tableData.map((key) => (
                        (key === 'site_no') ? {[key]: element['sites']['site_no']} : (key === 'site_name') ? {[key]: element['sites']['lead']['site_name']} :
                            {
                                [key]: element[key]
                            }
                        )
                    ),
                    {
                        'Approve/Reject': '',

                    }
                )
            );
            data && setListData(data);
            setPageCount(Math.ceil(sitePmStateList.total / sitePmStateList.per_page));
        }
    }, [sitePmStateList]);

    const updateApproval = async (data) => {
        setActionData(data);
        if (data.action === 'accept') {
            // setIsLoading(true);
            let params = {
                'id': data.actionObj.id,
                'status': 'approved'
            }
            await updatePmSiteState(params);
            setIsModal(true);
        } else {
            setIsModal(true);
        }
    };

    const handleModalHide = () => setIsModal(false);

    const successIconBox = (text, func) => {
        return (
            <div className="text-center">
                <div className="success">
                    <img src={Images?.tick} alt=""/>
                </div>
                <h5>{text}</h5>
                <Button onClick={() => setModelReset()} className="btn btn-transparent">
                    {localization.returnToApproval}{' '}
                    <img src={Images?.ArrowRight} alt=""/>
                </Button>
            </div>
        );
    };

    const onPageChange = async (val) => {
        setIsLoading(true);
        await getPmSiteState(val.selected + 1);
        setIsLoading(false);
    };

    const handleRejection = async (info) => {

        setIsModal(false);
        if (info.action === 'reject') {
            setIsLoading(true);
            let params = {
                'id': info.actionObj.id,
                'status': 'rejected'
            }
            await updatePmSiteState(params);
            setIsLoading(false);
            setIsSuccessModel(true);
        }
    };

    const setModelReset = () => {
        window.location.reload(true)
        setIsModal(false)
    }

    {console.log(getPmSiteState)}
    return (
        <Layout title={localization.pmSiteApproval} isLoading={isLoading} isGoback>
            <TableSection
                data={listData}
                headers={Headers}
                detailList={sitePmStateList && sitePmStateList.data}
                onChange={(data) => updateApproval(data)}
                pageCount={pageCount}
                onPageChange={onPageChange}
                isId={false}
                srNo={sitePmStateList?.from}
            />

            <ModalPop
                title={
                    actionData && actionData.action === 'reject'
                        ? localization.rejectConf
                        : localization.conf
                }
                show={isModal}
                handleModalHide={() => setIsModal(false)}
                actionData={actionData}
            >
                {actionData && actionData.action === 'reject' ? (
                    <div className="modal-body">
                        <div className="text-center">
                            <h5>Are you sure you want to reject?</h5>
                            <Button
                                className="btn btn-primary mb-4"
                                onClick={() => handleRejection(actionData)}
                            >
                                {localization.continue} <img src={Images?.ArrowRight} alt=""/>
                            </Button>
                            <Button
                                onClick={() => setModelReset()}
                                className="btn btn-transparent"
                            >
                                {localization.returnToApproval}{' '}
                                <img src={Images?.ArrowRight} alt=""/>
                            </Button>
                        </div>
                    </div>
                ) : (
                    successIconBox(localization.approvePmSiteSuccess, handleModalHide)
                )}
            </ModalPop>
            <ModalPop
                title={localization.rejectSuccessfully}
                show={isSuccessModel}
                handleModalHide={() => setIsSuccessModel(false)}
            >
                {successIconBox(localization.pmSiteApproval, () =>
                    setIsSuccessModel(false)
                )}
            </ModalPop>
        </Layout>
    );
};

export default PmSiteApprovals;
